import useQuery from "./useQuery";
import useUser from "./useUser";

const Hook = (namespace, q, options) => {
  const user = useUser();

  const key = `catalogs/${namespace}?q=${q}&locale=${
    user.state.language || ""
  }&country=${user.state.country}&v=3`;

  // Bug real (auditoría 2026-08-14): forzar initialData:[] cuando el
  // caller no pide una explícita hace que isLoading dé `false` desde el
  // primer render, aunque el fetch real siga en vuelo — Diagnoses.js
  // depende de `!catalog.isLoading` para decidir si tratar un resultado
  // vacío como "de verdad no hay nada" (allowNew de Typeahead); con la
  // máscara, lo trataba como vacío-confirmado antes de que el catálogo
  // siquiera llegara a pedirse.
  return useQuery(key, options);
};

export default Hook;
